const leadPreferences = {
  leadPreferences: {
    pageHeader: 'Leads Preferences',
    confirmMessage: 'Are you sure you want to save your lead preferences and go to the Add user page?',
    notInterested: {
      radioOptions0: 'Lack of time/resources to service new leads',
      radioOptions1: 'Only interested in signed homeowner contracts',
      radioOptions2: 'Do not want to disclose price range',
      radioOptions3: 'Other',
      selectReason: 'Please select a reason for opting out of the Enphase Leads Program',
      otherComments: 'Any other comments'
    },
    programOverview: {
      notInterestedText: 'We are not interested in participating in the Enphase Leads Program at the moment'
    },
    serviceDetailsSection: {
      min: 'Min',
      max: 'Max',
      maxLessMin: 'Max value cannot be less than or equal to Min value',
      enterInRange: 'Please enter numbers between %{serviceMInValue} and %{serviceMaxValue} only',
      note: 'Note',
      noteText:
        'A price range will be shown to the homeowner based on this input. This price should be inclusive of taxes but not incentives.',
      noteTextAus:
        'A price range will be shown to the homeowner based on this input. This price should be inclusive of GST but not incentives.',
      sizeRange: 'Size Range',
      pricePerkWh: 'Price per kWh',
      lessThan20kWh: 'Less than 20 kWh',
      greaterThan20kWh: '20 to 40 kWh'
    },
    serviceAreaSection: {
      title: 'Admin Access and Service Area',
      manageAdminAccess: 'Manage Admin Access',
      addNewUser: '+ Add New User',
      selectOneAdmin:
        'Please select one admin user from your company who will be the single point of contact in case Enphase wants to reach out to you for escalations related to any lead.',
      selectUser: 'Select User',
      otherAdmin:
        '#The other admin users in the above list will still be receiving alerts for all new leads and their updates. They can switch them off by updating their notification preferences if needed.',
      serviceArea: 'Service Area',
      addServiceAreas: ''
    },
    addUserDialog: {
      yes: 'Yes'
    },
    acModule: {
      optIn: 'Opt-in for installation of Enphase Energized AC Modules',
      description:
        'Homeowner expresses interest in an AC Module based system. You will procure and install the AC Modules. Enphase Energized AC Modules combine the latest cutting-edge microinverter technology from Enphase with the high-efficiency Solar Panels. They combine aesthetics and performance into an elegant product that reduces installation time by combining the inverter & panel into a single unit.'
    },
    sampleQuotes: {
      title: 'Indicative Pricing for Leads',
      useSlider:
        'Use the sliders below to see how your price range inputs are translated to an indicative price range for Homeowners for different system sizes',
      description:
        'Based on your inputs, the indicative price range that homeowners will see will be displayed here. You can also check how the price range will vary by system size.',
      solarOnly: 'Solar Installation',
      storageOnly: 'Storage Installation',
      solarStorage: 'Solar + Storage Installation',
      solarExpansion: 'Solar Expansion',
      turnkeyACM: 'Storage Installation + ACM Upgrade',
      microUpgrade: 'Microinverter Upgrade',
      turnkeyIQSeries: 'Storage Installation + Microinverters Upgrade',
      installationACM: 'Storage Installation + ACM Upgrade',
      installationIQSeries: 'Storage Installation + Microinverters Upgrade',
      installationSolar: 'Solar Installation',
      installationStorage: 'Storage Installation/Expansion',
      turnkeyNew: 'Turnkey Price for New Homeowners',
      turnKeyExisting: 'Turnkey Price for Existing Homeowners',
      turnkeyNewUS: 'Turnkey Price for Homeowners',
      installationUS: 'Installation only Price for Homeowners',
      installation: 'Installation Only Quotes for M-190 Micro Customers',
      turnkeyPrice: 'Turnkey Price',
      installation2: 'Installation Only Price for Referral Customers',
      installation3: 'Installation-Only Price',
      microinverterFootnote: 'Microinverter upgrade price may be added depending on the age of the site',
      solar: 'Solar',
      storage: 'Storage'
    },
    operationMaintenance: {
      label: 'Opt-in for O&M Services',
      description:
        'Operations and Maintenance (O&M) services include the support and maintenance of existing Enphase systems and Orphan Systems (sites with an inactive installer). All O&M leads will be provided with full site details and support history. For all O&M leads, Enphase standard product warranty will apply. Previous workmanship warranty would not apply for the Orphan Systems.'
    },
    leadProgram: {
      optIn: 'Opt-in for Enphase Leads Program',
      description:
        'Homeowners contact Enphase for new installs, upgrades and ongoing system maintenance. As an Enphase partner, you now have the opportunity to serve these homeowners through the Enphase Leads Program, which will match you to prospective homeowners.',
      programHighlights: 'Program Highlights:',
      keyTerms1: 'Enphase will provide free qualified leads from your service area',
      keyTerms2: 'Customer profile and project details will be provided for each lead before the first contact',
      keyTerms3: 'Enphase will assist in scheduling, appointment, project updates and technical support',
      keyTerms4: 'Installers are expected to respond and contact each lead and send a quote within 2 business days',
      keyTerms5: 'As part of the program only Enphase products shall be used',
      leadProgramPreferences: 'Lead program preferences',
      someLeads:
        'Some leads might require installation services only. Please indicate below if you want to opt-in for such leads.',
      tooltipTitle1:
        'Services you provide to homeowners. Enphase will match you with homeowners based on your selected service preferences',
      turnKey: 'Turn-key Services',

      tooltipTitle2: 'You provide all equipment, design, permitting and installation services',
      installationService: 'Installation only services',
      tooltipTitle3:
        'Homeowner elects to procure Enphase equipment from the Enphase store. You provide the remaining equipment, design, permitting and installation services',
      solarNew: 'Solar – New Installations',
      solarUpgrades: 'Solar - Upgrades',
      storageNew: 'Storage - New installations'
    },
    textContent: {
      preference: {
        title: 'Leads Program Preferences',
        caption: 'Disclaimer',
        description:
          'Enphase will show the pricing range provided by you for each preference below to the homeowners. It will be shown with a disclaimer that this pricing is budgetary and reflects the scope of work for a typical system only. Actual pricing is subject to change depending on location, roof type/pitch, electrical panel upgrade and relocation of the system to a different place.​',
        atleaseOne: '* select at least one service'
      },
      programreview: {
        title: 'Program Overview',
        description:
          'Homeowners contact Enphase for new installs, upgrades and ongoing system maintenance. As an Enphase partner, you now have the opportunity to serve these homeowners through the Enphase Leads Program which will match you to prospective homeowners. Please review the key terms below and specify your preferences for this program.'
      },
      keyProgramTerms: {
        title: 'Key Program Terms',
        enphaseProduct: 'As part of the program only Enphase products shall be used',
        appointment: 'Enphase will assist in scheduling appointments and provide other support as needed',
        contact: 'Installers are expected to contact each lead within 2 business days',
        project: 'Customer profile and project details will be provided for each lead before the first contact',
        verifiedAccount: 'Enphase will provide free qualified leads from your service area'
      },
      TurnKey: {
        title: 'Turnkey Services',
        description: `Turn-key Services means installer provides all bill of material, designing, permitting, installation and commissioning as applicable. Installer does the project and site assessment before providing a detailed quote.​The price indicated includes the total estimated cost to the homeowner for a system to be activated.`,
        solar: {
          indicativePricing: 'Indicative pricing range per Watt',
          quoteSizeIn: 'kW',
          main: 'Solar - Installation',
          sub: 'A new Solar system installation.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installer',
              sub:
                'Provides turn-key pricing and procures all required bill of material such as Modules, Microinverters (or alternatively AC Modules), IQ Combiner box, Accessories kit, Circuit breakers, Cellular modem, Cables and Racking.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: 'Price range is for a typical site and does not include a main panel upgrade and special-type roof.'
            }
          }
        },
        storage: {
          indicativePricing: 'Indicative pricing range per kWhr',
          indicativePricingStorageSlabs: 'Indicative pricing per kWh',
          main: 'Storage - Installation',
          quoteSizeIn: 'kWh',
          sub: 'A new Storage system installation',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installer',
              sub:
                'Provides turn-key pricing and procures all required bill of material such as IQ Battery storage, IQ System Controller switch, Cellular modem, Accessories kit and Cables​.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: `Indicative price range does not include main panel upgrade.`
            }
          }
        },
        microinverter: {
          indicativePricing: 'Indicative pricing range per Watt',
          main: 'Microinverter - Upgrade',
          quoteSizeIn: 'kW',
          sub:
            'Microinverter upgrade for an M-series (e.g. M-215, M-250) based solar system to a new IQ-based solar system which usually accompanies a "Storage - Installation"',
          sub2:
            'Microinverter upgrade for an M-series (e.g. M-215, M-250) based solar system to a new IQ-based solar system',
          subUS: 'Microinverter upgrade for an existing solar system to covert them into a new IQ-based solar system.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installer',
              sub: 'Provides turn-key pricing and procures all required bill of material.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: 'Indicative price range does not include main panel upgrade and solar panel upgrades.'
            }
          }
        }
      },
      installationOnly: {
        title: 'Installation Only Services (for Special Programs)',
        titleUS: 'Installation Only Services',
        sub: '(e.g. Homeowners with M-190 based solar panels, Enphase friends & family)',
        description:
          'Installation Only Services means homeowner procures Enphase bill of material from Enphase Store. All other materials and services are provided directly by the installer (wiring, racking, designing, permitting, installation and commissioning as applicable).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Indicative installation-only pricing range per Watt',
          main: 'Solar - Installation',
          sub: 'New installation for special programs or full-upgrade of an M-190/M-210/M-175/D380 based solar system',
          subUS: 'A new solar system installation',
          details: {
            homeOwner: {
              main: 'Homeowner',
              sub:
                'Purchases required bill of material from Enphase​ Store such as AC Modules, IQ​ Combiner box, Accessories kit and Circuit breakers.'
            },
            installer: {
              main: 'Installer',
              sub: 'Provides Racking, ​Wiring, Permitting, Installation and Commissioning.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: `Indicative price range does not include main panel upgrade and special-type roof installation​.`
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Indicative pricing installation-only range per kWhr',
          indicativePricingStorageSlabs: 'Indicative installation-only pricing per kWh',
          main: 'Storage - Installation',
          sub:
            'Storage addition to an existing solar system for special programs or for an M-190/M-210/M-175/D380 based solar system',
          subUS: 'A new Storage system installation',
          details: {
            homeOwner: {
              main: 'Homeowner',
              sub:
                'Purchases required bill of material from Enphase​ Store such as IQ Battery storage, Enpower switch, Accessories kit, Gateway (if required IQ Combiner box, Cellular Modem and/or Consumption CT)​.'
            },
            installer: {
              main: 'Installer',
              sub: 'Provides Permitting, Installation and Commissioning.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: `Indicative price range does not include main panel upgrade.`
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Indicative installation-only pricing range per Watt',
          main: 'Microinverters - Upgrade',
          sub: `Microinverter upgrade for an M-190/M-210/M-175/D380 based solar system to a new IQ-based solar system which usually accompanies a "Storage - Installation"`,
          sub2:
            'Microinverter upgrade for an M-series (e.g. M-215, M-250) based solar system to a new IQ-based solar system',
          subUS: 'Microinverter upgrade for an existing solar system to covert them into a new IQ-based solar system.',
          details: {
            homeOwner: {
              main: 'Homeowner',
              sub:
                'Purchases required bill of material from Enphase​ Store such as Microinverters, IQ​ Combiner box, Accessories Kit and Circuit breakers.​'
            },
            installer: {
              main: 'Installer',
              sub: 'Provides Permitting, Replacement, Recommissioning and Recycling of old Microinverters.​'
            },
            assumptions: {
              main: 'Assumptions',
              sub: `Indicative price range does not include main panel upgrade and racking changes.`
            }
          }
        }
      },
      omServices: {
        title: 'Enphase O&M Services',
        om: {
          main: 'Opt-in for Enphase O&M Services',
          pre: '- Including Orphan Systems',
          sub: `Operations and Maintenance (O&M) services include the support and maintenance of existing Enphase systems and Orphan Systems (sites with an inactive installer). All O&M leads will be provided with full site details and support history. For all O&M leads, Enphase standard product warranty will apply. Previous workmanship warranty would not apply for the Orphan Systems.`
        }
      },
      otherServices: {
        title: 'Other Preferences',
        buy: 'We are willing to buy Products from',
        acModule: {
          main: 'We are willing to install Enphase Energized AC Modules',
          sub1: `Enphase Energized AC Modules `,
          sub2: `combine the latest Microinverter technology from Enphase with the high-efficiency Solar Panels. They combine aesthetics and performance into an elegant product that reduces installation time by combining the inverter & panel into a single unit. By selecting this option, Enphase will match you with the homeowners who are willing to install AC Modules.`
        },
        enstore: {
          main: 'Enphase Store',
          sub1: `Enphase Store `,
          sub2: `is a one-stop-shop for Solar and Storage products with guaranteed delivery. Store requires no minimum order quantity and provides real time delivery and online tracking.​`,
          subIndia: `is a one-stop-shop for Solar products with guaranteed delivery. Store requires no minimum order quantity and provides real time delivery and online tracking.​`
        },
        distributor: {
          main: 'Enphase Distributors',
          sub1: `Enphase distributors`,
          sub2: ` supply all Enphase products and other required accessories for your Solar & Storage solution​`,
          subIndia: ` supply all Enphase products and other required accessories for your Solar solution​`
        },
        permitAssistance: {
          main: 'We are interested in Permit Assistance Service from Enphase',
          sub: `Enphase will assist you with Solar and Storage Permit Packages for your sites that you can submit to your Local Authority for approval.`
        },
        financeProvider: {
          // TODO - new translations added
          main: 'We provide financing options for Homeowners',
          // TODO ends
          no: 'No',
          yes: 'Yes',
          financeProvider: 'Finance providers',
          others: 'Other Providers',
          addMultiple: 'up to 3 (separated by comma)',
          requiredSelection: 'Required Selection',
          atLeastOneError: `Invalid finance providers (atleast enter one provider name when "Other Providers" selected)`
        }
      },
      serviceArea: {
        name: 'ADD SERVICE AREAS',
        sub: 'No Area added',
        description: `Please add your service areas. This is needed for Enphase to be able to match you with prospective homeowner leads.`
      },
      qualifyLeads: {
        mainSection:
          'Do you want Enphase representatives to qualify the leads over a phone call before sharing them with you?',
        moreInfo: 'Please let us know if there is any specific information you want us to collect for your leads.',
        infoWeCollect: 'to know what information we collect as part of our qualification procees',
        subSection:
          'Upon qualification, do you want the lead to be transfered to one of your representatives while the homeowner is on phone with us?',
        details: 'Please select one admin user from your company to whom such leads should be transferred to',
        icCheckList: 'Qualification Checklist',
        selectOption: 'Please select an option',
        selectUser: 'Please select a user'
      }
    },
    textContentAu: {
      preference: {
        title: 'Leads Program Preferences',
        caption: 'Disclaimer',
        description: `Enphase will show the pricing range provided by you for each preference below to the homeowners. It will be shown with a disclaimer that this pricing is budgetary and reflects the scope of work for a typical system only. Actual pricing is subject to change depending on location, roof type/pitch, electrical panel upgrade and relocation of the system to a different place.​`,
        atleaseOne: `* select at least one service`
      },
      programreview: {
        title: 'Program Overview',
        description: `Homeowners contact Enphase for new installs, upgrades and ongoing system maintenance. As an Enphase partner, you now have the opportunity to serve these homeowners through the Enphase Leads Program which will match you to prospective homeowners. Please review the key terms below and specify your preferences for this program.`
      },
      keyProgramTerms: {
        title: 'Key Program Terms',
        enphaseProduct: 'As part of the program only Enphase products shall be used',
        appointment: 'Enphase will assist in scheduling appointments and provide other support as needed',
        contact: 'Installers are expected to contact each lead within 2 business days',
        project: 'Customer profile and project details will be provided for each lead before the first contact',
        verifiedAccount: 'Enphase will provide free qualified leads from your service area'
      },
      TurnKey: {
        title: 'Turnkey Services',
        description: `Turnkey services mean the provision of a bill of materials, system design, permitting, installation, and commissioning as applicable. Installer does the project and site assessment before providing a detailed quote.​ The price indicated should include the total estimated cost to the homeowner for a system activation`,
        solar: {
          indicativePricing: 'Indicative pricing range per Watt',
          quoteSizeIn: 'kW',
          main: 'Solar - Installation',
          sub: 'A new Solar system installation.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installer',
              sub:
                'Provides turnkey pricing and procures all required bill of materials such as modules, microinverters, accessories, circuit breakers, cellular modem, cables, and racking.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: `Price range is for a typical site and does not include a main panel upgrade and special-type roof.`
            }
          }
        },
        storage: {
          indicativePricing: 'Indicative pricing range per kWhr',
          main: 'Storage - Installation',
          quoteSizeIn: 'kWh',
          sub: 'A new Storage system installation',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installer',
              sub:
                'Provides turnkey pricing and procures all required bill of material such as ACB storage, bracket, wiring and circuit breakers.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: `Indicative price range does not include main panel upgrade.`
            }
          }
        },
        microinverter: {
          indicativePricing: 'Indicative pricing range per Watt',
          main: 'Microinverter - Upgrade',
          quoteSizeIn: 'kW',
          sub:
            'Microinverter upgrade for an M-series (e.g. M-215, M-250) based solar system to a new IQ-based solar system which usually accompanies a "Storage - Installation"',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installer',
              sub: 'Provides turn-key pricing and procures all required bill of material.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: 'Indicative price range does not include main panel upgrade and solar panel upgrades.'
            }
          }
        },
        solarExpansion: {
          indicativePricing: 'Indicative pricing range per Watt',
          quoteSizeIn: 'kW',
          main: 'Solar System Expansion',
          sub: 'Expansion of existing Enphase and non-Enphase solar systems',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installer',
              sub: 'Provides turn-key pricing and procures all required bill of material.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: `Price range is for a typical site and does not include a main panel upgrade and special-type roof.`
            }
          }
        }
      },
      installationOnly: {
        title: 'Installation Only Services (for Special Programs)',
        sub: '(e.g. Orphaned systems need replacing/repair, Battery upgrade, Gateway upgrade)',
        description:
          'Installation Only Services means homeowner procures Enphase bill of material from Enphase Store. All other materials and services are provided directly by the installer (wiring, racking, designing, permitting, installation and commissioning as applicable).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Indicative installation-only pricing range per Watt',
          main: 'Solar - Installation',
          sub: `New installations for special programs such as referral leads from Enphase customers, installers, and employees.`,
          details: {
            homeOwner: {
              main: 'Homeowner',
              sub: `Purchases required bill of material from Enphase Store such as Microinverters, Accessories kit, Gateway and Circuit breakers.`
            },
            installer: {
              main: 'Installer',
              sub: 'Provides Modules, Racking, ​Wiring, Permitting, Installation and Commissioning.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: `Indicative price range does not include main panel upgrade and special-type roof installation​.`
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Indicative pricing installation-only range per kWhr',
          main: 'Storage – Expansion or Installation',
          sub: 'ACB Storage expansion or installation to an existing solar system for special programs',
          details: {
            homeOwner: {
              main: 'Homeowner',
              sub: 'Purchases required bill of material from Enphase​ Store such as ACB storage, Bracket​.'
            },
            installer: {
              main: 'Installer',
              sub: 'Provides Installation and Commissioning.'
            },
            assumptions: {
              main: 'Assumptions',
              sub: `Indicative price range does not include main panel upgrade.`
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Indicative installation-only pricing range per Watt',
          main: 'Microinverters - Upgrade',
          sub: `Microinverter upgrade for an M-190/M-210/M-175/D380 based solar system to a new IQ-based solar system which usually accompanies a "Storage - Installation"`,
          details: {
            homeOwner: {
              main: 'Homeowner',
              sub:
                'Purchases required bill of material from Enphase​ Store such as Microinverters, IQ​ Combiner box, Accessories Kit and Circuit breakers.​'
            },
            installer: {
              main: 'Installer',
              sub: 'Provides Permitting, Replacement, Recommissioning and Recycling of old Microinverters.​'
            },
            assumptions: {
              main: 'Assumptions',
              sub: `Indicative price range does not include main panel upgrade and racking changes.`
            }
          }
        }
      },
      omServices: {
        title: 'Enphase O&M Services',
        om: {
          main: 'Opt-in for Enphase O&M Services',
          pre: '- Including Orphan Systems',
          sub: `Operations and Maintenance (O&M) services include the support and maintenance of existing Enphase systems and Orphan Systems (sites with an inactive installer). All O&M leads will be provided with full site details and support history. For all O&M leads, Enphase standard product warranty will apply.`
        }
      },
      otherServices: {
        title: 'Other Preferences',
        buy: 'I am willing to buy Products from',
        acModule: {
          main: 'I am willing to install Enphase Energized AC Modules',
          sub1: `Enphase Energized AC Modules `,
          sub2: `combine the latest Microinverter technology from Enphase with the high-efficiency Solar Panels. They combine aesthetics and performance into an elegant product that reduces installation time by combining the inverter & panel into a single unit. By selecting this option, Enphase will match you with the homeowners who are willing to install AC Modules.`
        },
        enstore: {
          main: 'Enphase Store',
          sub1: `Enphase Store `,
          sub2: `is a one-stop-shop for Solar and Storage products with guaranteed delivery. Store requires no minimum order quantity and provides real time delivery and online tracking.​`
        },
        distributor: {
          main: 'Enphase Distributors',
          sub1: `Enphase distributors`,
          sub2: ` supply all Enphase products and other required accessories for your Solar & Storage solution​`
        }
      },
      serviceArea: {
        name: 'ADD SERVICE AREAS',
        sub: 'No Area added',
        description: `Please add your service areas. This is needed for Enphase to be able to match you with prospective homeowner leads.`
      }
    },
    getLink: `Get link`,
    linkSENewLeads: `System Estimator Link for new leads`,
    shareSELink: `Share this link with your customers to help them estimate their Enphase system size and submit their details to get a lead in your Enlighten Manager`
  }
};

export default leadPreferences;
